import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';


const FilterBuildingModal = ({ open, handleClose, sortField, setSortField, order, setOrder, status, setStatus, type, setType }) => {


    const [sortFields, setSortFields] = useState([

        { key: 'buildingID', label: 'Building ID' },
        { key: 'addressID', label: 'Building Site' }, // This will be physical address
        { key: 'location', label: 'Location' },
        { key: 'customerID', label: 'Customer ID' },
        { key: 'agencyID', label: 'Management ID' },
        { key: 'buildingType', label: 'Building Type' },
        { key: 'dispatchType', label: 'Dispatch Type' },

    ]);

    const [statusOptions, setStatusOptions] = useState([
        { key: 0, label: 'All' },
        { key: 1, label: 'Active' },
        { key: 2, label: 'Cancelled' },
        { key: 3, label: 'Collection' },
        { key: 4, label: 'Pending' },
        { key: 5, label: 'Transferred' },
        { key: 6, label: 'Expired' },
    ]);

    const [typeOptions, setTypeOptions] = useState([
        { key: 0, label: 'All' },
        { key: 1, label: 'Commercial' },
        { key: 2, label: 'Company/Office' },
        { key: 3, label: 'Garage' },
        { key: 4, label: 'Government' },
        { key: 5, label: 'Hospital' },
        { key: 6, label: 'Nursing Home' },
        { key: 7, label: 'Other' },
        { key: 8, label: 'Parent Location' },
        { key: 9, label: 'Religious Facility' },
        { key: 10, label: 'Residential' },
        { key: 11, label: 'Restaurant' },
        { key: 12, label: 'School' },
        { key: 13, label: 'Ship' },
        { key: 14, label: 'Transportation Facility' },
    ]);

    const [orderOptions, setOrderOptions] = useState([
        { key: 'asc', label: 'Ascending' },
        { key: 'desc', label: 'Descending' },
    ]);
    const clearFilters = () => {
        setSortField('managementId');
        setOrder('asc');
        setStatus(0);
        setType(0);
    }



    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xl"
            fullWidth
        >
            <DialogTitle className="text-2xl font-bold">Filter Management Company Records</DialogTitle>
            <DialogContent dividers>
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                        <label htmlFor="sortField" className="text-lg font-semibold">Sort By</label>
                        <select
                            id="sortField"
                            value={sortField}
                            onChange={(e) => setSortField(e.target.value)}
                            className="p-2 border border-gray-300 rounded-lg outline-none"
                        >
                            {sortFields.map((field) => (
                                <option key={field.key} value={field.key}>{field.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="flex flex-col gap-2">
                        <label htmlFor="order" className="text-lg font-semibold">Order</label>
                        <select
                            id="order"
                            value={order}
                            onChange={(e) => setOrder(e.target.value)}
                            className="p-2 border border-gray-300 rounded-lg outline-none"
                        >
                            {orderOptions.map((option) => (
                                <option key={option.key} value={option.key}>{option.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="flex flex-col gap-2">
                        <label htmlFor="status" className="text-lg font-semibold">Status</label>
                        <select
                            id="status"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className="p-2 border border-gray-300 rounded-lg outline-none"
                        >
                            {statusOptions.map((option) => (
                                <option key={option.key} value={option.key}>{option.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="flex flex-col gap-2">
                        <label htmlFor="type" className="text-lg font-semibold">Type</label>
                        <select
                            id="type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            className="p-2 border border-gray-300 rounded-lg outline-none"
                        >
                            {typeOptions.map((option) => (
                                <option key={option.key} value={option.key}>{option.label}</option>
                            ))}
                        </select>

                    </div>
                </div>
                <div>
                    <DialogActions>
                        <button
                            onClick={clearFilters}
                            className="bg-red-500 text-white p-2 rounded-lg"
                        >
                            Clear Filters
                        </button>
                        <button
                            onClick={handleClose}
                            className="bg-gray-500 text-white p-2 rounded-lg"
                        >
                            Close
                        </button>
                    </DialogActions>
                </div>
            </DialogContent>
        </Dialog>

    );
};

export default FilterBuildingModal;
